import { createSlice } from '@reduxjs/toolkit'

const sortingSlice = createSlice({
  name: 'sorting',
  initialState: {},
  reducers: {
    setSorting(state, action) {
      const { table, column, ascending } = action.payload
      state[table] = { column, ascending }
    },
  },
})

export const { setSorting } = sortingSlice.actions

export default sortingSlice.reducer
